const env = process.env.NODE_ENV

function getHost(env: string, domain = 'huami.com') {
  return env === 'production' ? `user.${domain}` : `user-testing.${domain}`
}

export default function universalLogin({
  projectName = '',
  redirectUrl = '',
  platformAppName = 'com.huami.webapp',
  specifyLang = '',
  domain = 'huami.com'
}: {
  projectName: string
  redirectUrl: string
  platformAppName?: string
  specifyLang?: string
  domain?: string
}) {
  window.location.href = `https://${getHost(
    env,
    domain
  )}/universalLogin/index.html#/login?project_name=${projectName}&project_redirect_uri=${encodeURIComponent(
    redirectUrl
  )}&platform_app=${platformAppName}&specify_lang=${specifyLang}`
}

export function universalRegister({
  projectName = '',
  redirectUrl = '',
  platformAppName = 'com.huami.webapp',
  specifyLang = '',
  domain = 'huami.com'
}: {
  projectName: string
  redirectUrl: string
  platformAppName?: string
  specifyLang?: string
  domain?: string
}) {
  window.location.href = `https://${getHost(
    env,
    domain
  )}/universalLogin/index.html#/register?project_name=${projectName}&project_redirect_uri=${encodeURIComponent(
    redirectUrl
  )}&platform_app=${platformAppName}&specify_lang=${specifyLang}`
}
